import { Button, styled, Theme } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_BUTTON_BORDER,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_TEXT,
  LIGHT_BUTTON_BACKGROUND,
  LIGHT_BUTTON_BORDER,
  LIGHT_HEADER_LINE,
  PLAIN_TEXT,
  PRIMARY_HEADER_LINE,
  PRIMARY_BUTTON_BORDER,
} = COLORS;

const $gutter = 20;

export const MainContainer = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: 8,
  padding: '25px 30px',
  width: '100%',
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  position: 'relative',
  borderBottom:
    theme.palette.type === 'dark' ? `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}` : `1px solid ${LIGHT_HEADER_LINE}`,
  alignItems: 'center',
  paddingBottom: 15,
  margin: '0 0 20px',
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  '&::before': {
    content: '""',
    background: PRIMARY_HEADER_LINE,
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const SelectionContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 50%)',
  gap: $gutter,
  width: `calc(100% - ${$gutter}px)`,
  margin: '20px 0',

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const SelectionButton = styled(Button)<Theme, { isActive?: boolean; theme: any }>(
  ({ isActive = false, theme }) => ({
    background: theme.palette.type === 'dark' ? DARK_BUTTON_BACKGROUND : LIGHT_BUTTON_BACKGROUND,
    color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
    border: '1px solid',
    borderColor: isActive
      ? PRIMARY_BUTTON_BORDER
      : theme.palette.type === 'dark'
        ? LIGHT_BUTTON_BORDER
        : DARK_BUTTON_BORDER,
    opacity: isActive ? 1 : 0.3,
    height: 49,
    fontSize: 16,
  }),
);
